"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _ref2 = /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("path", {
  id: "path-1",
  fillRule: "evenodd",
  d: "M4 1h32.7736508c1.65574507 0 3 1.34425493 3 3v60.02c0 1.65574507-1.34425493 3-3 3H4c-1.65574507 0-3-1.34425493-3-3V4c0-1.65574507 1.34425493-3 3-3z"
}), /*#__PURE__*/_react.default.createElement("mask", {
  id: "mask-2",
  x: "0",
  y: "0",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: "40.774",
  height: "68.02",
  x: "0",
  y: "0",
  fill: "white"
}), /*#__PURE__*/_react.default.createElement("use", {
  fill: "black",
  xlinkHref: "#path-1"
})));

var _ref3 = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("use", {
  fillOpacity: "0",
  stroke: "rgb(244,67,54)",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeWidth: "2",
  mask: "url(#mask-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "rgb(244,67,54)",
  fillRule: "evenodd",
  d: "M17.35449848 17.85617021v22.82606383h7.02340426V17.85617021h-7.02340426z"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  cx: "20.866",
  cy: "46.652",
  fill: "rgb(244,67,54)",
  rx: "3.512",
  ry: "3.512"
}));

var ProductDetailDemoProductLinkWarningIcon = function ProductDetailDemoProductLinkWarningIcon(_ref) {
  var rest = (0, _extends2.default)({}, _ref);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.774",
    height: "68.02",
    viewBox: "0 0 40.774 68.02"
  }, rest), _ref2, _ref3);
};

var _default = ProductDetailDemoProductLinkWarningIcon;
exports.default = _default;